module.exports = __webpack_public_path__ + "static/img/new3.30a7195.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new3.jpeg
// module id = VyV+
// module chunks = 0